// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-flex;
  align-items: center;
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
}

.toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.marker {
  position: relative;
  width: 14px;
  height: 14px;
  border: 1px solid var(--border-color, #c8ced6);
  border-radius: 3px;
  background: var(--bg-primary, #fff);
  display: inline-block;
  transition: all 0.12s ease;
}

.toggle input:checked + .marker {
  background: var(--accent-color, #0066cc);
  border-color: var(--accent-color, #0066cc);
}

.toggle input:checked + .marker::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.label {
  font-size: 12px;
  line-height: 1.2;
  color: var(--text-secondary, #666);
}
`, "",{"version":3,"sources":["webpack://./src/checkbox-toggle.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC","sourcesContent":[":host {\n  display: inline-flex;\n  align-items: center;\n}\n\n.toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.toggle input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.marker {\n  position: relative;\n  width: 14px;\n  height: 14px;\n  border: 1px solid var(--border-color, #c8ced6);\n  border-radius: 3px;\n  background: var(--bg-primary, #fff);\n  display: inline-block;\n  transition: all 0.12s ease;\n}\n\n.toggle input:checked + .marker {\n  background: var(--accent-color, #0066cc);\n  border-color: var(--accent-color, #0066cc);\n}\n\n.toggle input:checked + .marker::after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  width: 4px;\n  height: 8px;\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.label {\n  font-size: 12px;\n  line-height: 1.2;\n  color: var(--text-secondary, #666);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
